import { Component } from 'react';

import { IActivityLog } from "../../../../../util/varibles/interface";
import HarvestView from "../../../../PlanOperationPage/_components/ContentOperation/HarvestView";
import styles from './style.module.scss';

interface IProps {
    operation: any
    activity_log: IActivityLog[]
    vessel: any
}

class Operation extends Component<IProps> {
    render() {
        const { operation, activity_log, vessel } = this.props;

        return <div className={styles.operation}>
            <HarvestView status={operation.status} isOwn={true} data={{ operation, vessel, activity_log }} />
        </div>;
    }
}

export default Operation;
